import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "pop_up applicant_chk com_pop",
  style: {"max-width":"1200px"}
}
const _hoisted_2 = { class: "pop_tit _flex" }
const _hoisted_3 = { class: "sch_condition_wrap" }
const _hoisted_4 = { class: "left _column _flex" }
const _hoisted_5 = { class: "date_wrap" }
const _hoisted_6 = {
  key: 0,
  class: "state_tag"
}
const _hoisted_7 = {
  key: 1,
  class: "state_tag waiting"
}
const _hoisted_8 = {
  key: 2,
  class: "state_tag finish"
}
const _hoisted_9 = { class: "collection_period" }
const _hoisted_10 = { class: "end_point" }
const _hoisted_11 = {
  key: 3,
  class: "activity_duration"
}
const _hoisted_12 = { class: "right _align_bottom _flex" }
const _hoisted_13 = { class: "list_container _flex" }
const _hoisted_14 = { class: "common_table custom_scroll" }
const _hoisted_15 = { class: "cnt" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["textContent"]
const _hoisted_19 = ["textContent"]
const _hoisted_20 = { class: "cnt p_5" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_CaseListModal = _resolveComponent("CaseListModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "pop_up_layer com_pop",
      style: {"display":"block"},
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, _toDisplayString($setup.state.item.title), 1),
        _createElementVNode("button", {
          class: "close_btn icon_wrap",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
        }, [...(_cache[6] || (_cache[6] = [
          _createElementVNode("img", {
            src: "img/close.png",
            alt: "닫기"
          }, null, -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            ($setup.state.item.state == 2)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "진행중"))
              : ($setup.state.item.state == 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "대기중"))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, "마감")),
            _createElementVNode("div", _hoisted_9, [
              _cache[7] || (_cache[7] = _createElementVNode("span", null, [
                _createElementVNode("img", {
                  src: "img/time_icon.png",
                  alt: ""
                }),
                _createTextVNode(" 모집기간 ")
              ], -1)),
              _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.dateFormatYY(new Date($setup.state.item.recruitStartDate), ".")), 1),
              _cache[8] || (_cache[8] = _createElementVNode("em", null, "-", -1)),
              _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.dateFormatYY(new Date($setup.state.item.recruitEndDate), ".")), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[9] || (_cache[9] = _createElementVNode("span", null, [
                _createElementVNode("img", {
                  src: "img/time_icon.png",
                  alt: ""
                }),
                _createTextVNode(" 신청종료일 ")
              ], -1)),
              _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.dateFormatYY(new Date($setup.state.item.applyDate), ".")), 1)
            ]),
            ($setup.state.item.activeStartDate && $setup.state.item.activeEndDate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _cache[10] || (_cache[10] = _createElementVNode("span", null, [
                    _createElementVNode("img", {
                      src: "img/cal_icon.png",
                      alt: ""
                    }),
                    _createTextVNode(" 활동기간 ")
                  ], -1)),
                  _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.dateFormatYY(new Date($setup.state.item.activeStartDate), ".")), 1),
                  _cache[11] || (_cache[11] = _createElementVNode("em", null, "-", -1)),
                  _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.dateFormatYY(new Date($setup.state.item.activeEndDate), ".")), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            type: "button",
            class: "blue_btn",
            style: {"padding":"0 10px"},
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showCase()))
          }, "질문추가+")
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("table", null, [
            _cache[15] || (_cache[15] = _createElementVNode("colgroup", null, [
              _createElementVNode("col", { style: {"width":"80px"} }),
              _createElementVNode("col", { style: {"width":"100px"} }),
              _createElementVNode("col"),
              _createElementVNode("col", { style: {"width":"140px"} })
            ], -1)),
            _createElementVNode("tbody", null, [
              ($setup.state.list.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.list, (item, idx) => {
                    return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                      _createElementVNode("td", _hoisted_15, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "move_up _sub",
                          onClick: ($event: any) => ($setup.changeOrder(item.idx, 0))
                        }, [...(_cache[12] || (_cache[12] = [
                          _createElementVNode("img", {
                            src: "img/up_icon.png",
                            alt: ""
                          }, null, -1)
                        ]))], 8, _hoisted_16),
                        _createElementVNode("button", {
                          type: "button",
                          class: "move_down _sub",
                          onClick: ($event: any) => ($setup.changeOrder(item.idx, 1))
                        }, [...(_cache[13] || (_cache[13] = [
                          _createElementVNode("img", {
                            src: "img/down_icon.png",
                            alt: ""
                          }, null, -1)
                        ]))], 8, _hoisted_17)
                      ]),
                      _createElementVNode("td", {
                        textContent: _toDisplayString($setup.strGubun(item.type))
                      }, null, 8, _hoisted_18),
                      _createElementVNode("td", {
                        textContent: _toDisplayString(item.title),
                        style: {"text-align":"left"}
                      }, null, 8, _hoisted_19),
                      _createElementVNode("td", _hoisted_20, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "table_btn _blue",
                          onClick: ($event: any) => ($setup.showCase(item))
                        }, "수정", 8, _hoisted_21),
                        _createElementVNode("button", {
                          type: "button",
                          class: "table_btn _gray",
                          onClick: ($event: any) => ($setup.isDelete(item.idx))
                        }, "삭제", 8, _hoisted_22)
                      ])
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("tr", _hoisted_23, [...(_cache[14] || (_cache[14] = [
                    _createElementVNode("td", { colspan: "6" }, [
                      _createElementVNode("div", {
                        class: "tb_subject",
                        style: {"text-align":"center","width":"100%"}
                      }, "등록한 신청 양식이 없습니다.")
                    ], -1)
                  ]))]))
            ])
          ])
        ])
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.state.isShowModal = false)),
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onCallback"]))
      : _createCommentVNode("", true),
    ($setup.state.isShowCaseModal)
      ? (_openBlock(), _createBlock(_component_CaseListModal, {
          key: 1,
          item: $setup.state.itemForItem,
          onClose: _cache[4] || (_cache[4] = ($event: any) => ($setup.state.isShowCaseModal = false)),
          onCallback: _cache[5] || (_cache[5] = ($event: any) => {
            $setup.state.isShowCaseModal = false;
            $setup.getList();
        })
        }, null, 8, ["item"]))
      : _createCommentVNode("", true)
  ], 64))
}